import React, { useEffect, useState, useContext, Fragment } from "react";
import { IntlProvider } from "react-intl";
import PAtabs from "./PAtabs";
import PATopBar from "./PATopBar";
import PAh2 from "./PAh2";
import styled, { css } from "styled-components";
import { ContextConsumer, GlobalContext } from "./PA";
import PASideBar from "./PASideBar";
import PAonboarding from "./PAonboarding";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Breadcrumbs,
  Head,
  FormFooter,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock,
} from "xsolla-uikit";

import PAviGroup, { vi } from "./ingame/PAviGroup";
import { PAviItems } from "./ingame/PAviItems";
import PAgkRefund from "./ffr/PAgkRefund";
import PAmodal from "./PApop";

import { CssCounter } from "./uikit2";

const pageSetupExample = {
  popup: false,
  root: "support",
  title: "",
  tabs: {
    subscribers: {
      title: "Subscribers",
      pill: <Pill appearance="active">+8</Pill>,
      component: <PAgkRefund type="ingame" />,
      icon: "profile",
      // noTitle,
    },
    users2: {
      title: "In-game store customers",
      component: <PAviGroup showAsPage={false} />,
      counter: 34,
    },
    users3: {
      title: "Game store customers",
      icon: "profile",
    },
  },
};

const examplePages = {
  susbscribers: {
    title: "Subscribers",
    component: ``,
    extra: <Pill appearance="active">+8</Pill>,
  },
  customers: {
    title: "Customers",
    component: `<ContentBlock><PAh2 title="Customers" indentation="lg"/></ContentBlock>`,
  },
};

export default function PApage({
  version = "poydo",
  dashboard,
  border='md',
  ...props
}) {
  return (
    <div
      className="pabody"
      style={{
        // placeSelf: "start center",
        width: "100%",
        display: "flex",
        // display: version === "poydo" ? "flex" : "flex",
        // color: version === "misha" ? "white" : "inherit",
        // background: version === "misha" ? "transparent" : "inherit",
        flexDirection:
          version === "poydo" ? "row" : version === "misha2" ? "row" : "column",
        // maxWidth: version === "poydo" ? "100%" :
        // version === "misha2" ? "100%" :
        // 1080
        maxWidth: "100%",
      }}
    >
      {/* {!!dashboard && useContext(GlobalContext).globalState.version === "misha" &&  (
        <CSSdashBg/>
      )} */}

      {version === "poydo" && <PASideBar />}
      {version === "misha2" && <PAonboarding />}
      {version === "misha" && <PATopBar />}

      <PApageInner {...props} />
    </div>
  );
}

export function PApageInner({
  popup,
  dashboard,
  width = "100%",
  hist,
  root = pageSetupExample["root"],
  tabs,
  title = pageSetupExample["label"],
  extra,
  border = 'sm',
  defaultPage,
  appearance,
  size,
  style,
}) {
  root = root ? `${root}` : `/${tabs ? Object.keys(tabs)[0] : "/"}`;

  const [active, setActive] = useState();
  const [sub, setSub] = useState();

  useEffect(() => {
    let newPage = hist.match.params.keyId || null;
    let newSubPage = hist.match.params.pageId;
    console.log("newSubPage = ", newSubPage);

    // let longPath = hist.location.pathname;
    // let shortPath = hist.match.url;
    // // debugger
    // var start = longPath.indexOf(shortPath);
    // var end = start + shortPath.length;
    // // let newSubPage = hist.location.pathname.replace(`/${hist.match.url}`, '')
    // let newSubPage = longPath.substring(0, start - 1) + longPath.substring(end);
    // setSub(newSubPage);

    if (!newPage && !newSubPage && tabs) {
      hist.history.push(`/${root}/${Object.keys(tabs)[0]}`);
      setActive(newPage);
    }
    if (newPage && newPage !== active) {
      hist.history.push(`/${root}/${newPage}`);
      setActive(newPage);
    }

    // if (newPage && tabs[newPage]['slideTo'] && hist.location.hash !== `#${tabs[newPage]['slideTo']}`) {
    // debugger
    // hist.history.push(`#${tabs[newPage]['slideTo']}`)
    // setActive(newPage);
    // }

    // if (typeof newSubPage !== 'undefined') {
    //   setSub(newSubPage)
    // }

    // if (!newPage) {
    //   debugger
    //   hist.history.push(`/${root}/${newPage}${newSubPage}`);
    // }

    // if (newPage && newPage !== active) {
    //   debugger
    //   hist.history.push(`/${root}/${newPage}${newSubPage}`);
    //   // setActive(newAction);
    // }

    // if (
    //   active &&
    //   newPage &&
    //   longPath !== `${root}/${newPage}${newSubPage}`
    // ) {
    //   debugger;
    //   hist.history.push(`/${root}/${newPage}${newSubPage}`);
    //   // setActive(newAction);
    // }

    return () => {};
  }, [hist]);

  const renderTabs = (tabs = {}) => {
    let tabsArr = Object.keys(tabs);
    if (tabsArr.length)
      return tabsArr
        .filter((oneTabName) => {
          let oneTab = tabs[oneTabName];
          if (!oneTab["label"] || oneTab["customTrigger"]) {
            return false; // skip
          }
          return true;
        })
        .map((oneTabName, ind) => {
          let oneTab = tabs[oneTabName];
          if (oneTab)
            return {
              name: (
                <CssTab key={`tab_${oneTabName}_${ind}`}>
                  {oneTab["label"]}
                  {!!oneTab["counter"] && (
                    <CssCounter>{oneTab["counter"]}</CssCounter>
                  )}
                  {!!oneTab["status"] && (
                    <CssExtra>{oneTab["status"]}</CssExtra>
                  )}
                </CssTab>
              ),
              stateName: oneTabName,
              icon: oneTab["icon"],
            };
        });
  };

  const renderCont = (oneTab, sub, first) => {
    if (oneTab["component"] || sub)
      return (
        <FormGroup indentation="lg"
          key={`tab_${oneTab['title']}`}
        >
          <CssPage0
            full={oneTab["size"] === "full" ? true : false}
            wide={oneTab["size"] === "wide" ? true : false}
          >
            <ContentBlock
              style={{ width: "100%" }}
              // key={`tab_${ind}`}
              appearance={
                // !oneTab["components"] ? oneTab["appearance"] : "flatten"
                oneTab["appearance"]
                  ? oneTab["appearance"]
                  : oneTab["size"] === "full"
                  ? "flatten"
                  : "primary"
              }
            >
              {sub && !!oneTab["pop"] && (
                <PAmodal
                  size={oneTab["pop"]["size"] || "md"}
                  header={oneTab["pop"]["title"]}
                  handleModal={() =>
                    hist.history.push(oneTab["pop"]["backUrl"])
                  }
                >
                  {oneTab["pop"]["component"]}
                </PAmodal>
              )}

              {!!oneTab["title"] && (

                <FormGroup indentation="lg" border={border}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "stretch",
                    }}
                    className='pam__title'
                  >
                    <CSSpageTabs>
                      <PAh2
                        title={oneTab["title"]}
                        tag="h2"
                        indentation="xs"
                        first={first}
                      />{" "}
                      {!!oneTab["cta"] && <CssCTA>{oneTab["cta"]}</CssCTA>}{" "}
                    </CSSpageTabs>
                    {!!oneTab["extra"] && (
                      <CssH2Extra>{oneTab["extra"]}</CssH2Extra>
                    )}
                  </div>
                </FormGroup>
              )}

              <FormGroup indentation="lg">{oneTab["component"]} </FormGroup>
            </ContentBlock>
          </CssPage0>
        </FormGroup>
      );
  };

  return (
    <CssPage0

      // className="xsui-width"
      full={size === "full" ? true : false}
      style={{
        width: useContext(GlobalContext).globalState.version === "poydo" ? 'calc(100vw - 220px)' : '99vw',
        padding: size === "full" || size === "wide" ? 0 : "24px 24px",
        ...style,
      }}
    >
      {!!title && (
        <CSSmenu
          // className={appearance === 'full' ? '' : "xsui-content-block"}
          className='pam__title'
          style={{
            background:
              useContext(GlobalContext).globalState.version === "misha"
                ? "#011627"
                : "#f5f9ff",
          }}
        >
          <ContentBlock
            appearance={"flatten"}
            style={{
              // position: "sticky",
              // top: 0,
              // zIndex: 100,
              // boxShadow: '-8px 0 8px 0 rgb(245, 249, 255), 8px 0 8px 0 rgb(245, 249, 255)',
              marginBottom: 24,
            }}
          >
            <FormGroup indentation="lg">
              <FormGroup indentation="md">
                {useContext(GlobalContext).globalState.version === "misha" && (
                  <CssMenuSticky />
                )}

                <CSSpageTitle
                  className='xsui-page-header'
                >
                  {/* <Breadcrumbs
              items={[
                {
                  label: title,
                  to: root,
                }
              ]}
            /> */}
                  {/* <div
                    style={{
                      // flexGrow: 1,
                      display: "flex",
                      alignItems: "center",
                      paddingBottom: 8,
                      marginRight: 16
                    }}
                  > */}
                  <PAh2 indentation="xs" tag="h1" title={title} wrap="nowrap" />
                  {/* </div> */}

                  {tabs && (
                    <CSSpAtabs0>
                      <PAtabs
                        appearance="secondary"
                        active={active}
                        handleTab={(nw) => {
                          hist.history.push(`/${root}/${nw}`);
                        }}
                        items={renderTabs(tabs)}
                        // extra='123'
                        extra={extra}
                      />
                    </CSSpAtabs0>
                  )}
                </CSSpageTitle>
              </FormGroup>
            </FormGroup>
          </ContentBlock>
        </CSSmenu>
      )}

      {tabs &&
        // && !hist.match.params.pageId
        Object.keys(tabs).indexOf(active) >= 0 &&
        Object.keys(tabs).map((oneTabName, ind) => {
          let oneTab = tabs[oneTabName];

          if (
            oneTab &&
            oneTabName === active
            // && !hist.match.params.pageId
          ) {
            return (
              <div key={`tab_${oneTab['title']}`}>
                {!!oneTab &&
                  !!oneTab["component"] &&
                  // && !hist.match.params.pageId
                  renderCont(oneTab)}

                {!oneTab["components"] && !!oneTab["pop"] && (
                  <PAmodal
                    size={oneTab["pop"]["size"] || "md"}
                    header={oneTab["pop"]["title"]}
                    extra={oneTab["pop"]["extra"]}
                    handleModal={() =>
                      hist.history.push(oneTab["pop"]["backUrl"])
                    }
                  >
                    {oneTab["pop"]["component"]}
                  </PAmodal>
                )}

                {!!oneTab &&
                  !!oneTab["components"] &&
                  oneTab["components"].map((oneComp, ind) => {
                    return renderCont(oneComp, "sub");
                  })}

                {!!oneTab &&
                  !!hist.match.params.pageId &&
                  !!oneTab["subComponent"] &&
                  renderCont(oneTab["subComponent"], true)}

                {/* {!!oneTab
                && !!hist.match.params.pageId
                && !!oneTab["subComponent"]
                && oneTab["subComponent"]['pop']['component']} */}

                {/* {!(oneTab['noTitle'] && !oneTab['components']) && renderCont(oneTab)} */}
              </div>
            );
          }

          // if (oneTab
          //   && oneTabName === active
          //   && !!hist.match.params.pageId
          //   ) {
          //   // let id = sub;
          //   // id = id.split('/')[1];
          //   // console.log('sub = ', id);
          //   return (
          //     <div className="">
          //       {!!oneTab && !!oneTab["subComponent"] && oneTab["subComponent"]}

          //     </div>
          //   )
          // }

          // if (oneTab
          //   // && oneTabName === active
          //   && oneTab['subPage']) {
          //   <PApage
          //     hist={hist}
          //     root={oneTab['subPage']['root']}
          //     {...oneTab['subPage']}
          //   />
          // }
        })}

      {(!tabs || (Object.keys(tabs).indexOf(active) === -1 && defaultPage)) &&
        !hist.match.params.pageId && (
          <Fragment>
            <ContentBlock
              appearance={
                defaultPage["appearance"]
                  ? defaultPage["appearance"]
                  : "primary"
              }
            >
              {/* {defaultPage["component"]} */}

              {renderCont(defaultPage, "sub")}
            </ContentBlock>

            {defaultPage["components"] &&
              defaultPage["components"].map((oneComp, ind) => {
                return renderCont(oneComp, "sub");
              })}
          </Fragment>
        )}
    </CssPage0>
  );
}

const CssPage0 = styled.div`
  width: 100%;

  ${({ full }) =>
    full &&
    css`
      & .xsui-content-block {
        max-width: none;
        /* left: -24px;
        top: -24px;
        right: -24px; */
      }
    `};
  ${({ wide }) =>
    wide &&
    css`
      /* padding: 24px; */

      & .xsui-page-header,
      & .pam__title .xsui-content-block,
      & .xsui-content-block {
        max-width: none !important;
        /* left: -24px;
        right: -24px;
        padding-left: 44px;
        padding-right: 44px;
        width: calc(100% + 48px) */
      }


    `};
`;

const CssTab = styled.span`
  display: flex;
  align-items: center;
`;

const CssMenuSticky = styled.div`
  position: absolute;
  /* left: 0px;
  right: 0px; */
  /* left: -1000px; */
  /* right: -1000px; */
  height: 68px;
  /* background: #d6e0e7; */
  background: #f7faff;
  z-index: -1;
`;

const CssCTA = styled.div`
  /* flex-grow: 1; */
  display: flex;
  /* justify-content: flex-end; */
  margin-left: 1em;
  margin-top: 4px;
`;

const CSSpageTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 767px) {
    display: block;
  }
`;

const CSSpageTabs = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    display: block;
  }
`;

const CSSmenu = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  margin-bottom: 24px;
  /* // margin: '0 -16px 0 16px', */
  @media (max-width: 767px) {
    margin-left: -24px;
    padding-left: 24px;
  }
`;

const CssExtra = styled.span`
  margin-left: 0.6em;
`;
const CssH2Extra = styled.span`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  @media (max-width: 767px) {
    justify-content: flex-start;
  }
`;
export const CSSpAtabs0 = styled.div`
  display: flex;
  width: 100%;
  justify-content: stretch;
  padding: 8px 0 0 24px;
  @media (max-width: 767px) {
    padding: 0;
  }
`;
